<template>
  <div class="privacy-content" v-html="content"></div>
</template>

<script>
import arHtml from "!!raw-loader!@/components/data-privacy/data-privacy-ar.html";
import chHtml from "!!raw-loader!@/components/data-privacy/data-privacy-ch.html";
import deHtml from "!!raw-loader!@/components/data-privacy/data-privacy-de.html";
import enHtml from "!!raw-loader!@/components/data-privacy/data-privacy-en.html";
import esHtml from "!!raw-loader!@/components/data-privacy/data-privacy-es.html";
import frHtml from "!!raw-loader!@/components/data-privacy/data-privacy-fr.html";
import jaHtml from "!!raw-loader!@/components/data-privacy/data-privacy-ja.html";
import tuHtml from "!!raw-loader!@/components/data-privacy/data-privacy-tu.html";
export default {
  data() {
    return {
      content: "",
    };
  },
  created() {
    this.loadPrivacyContent(this.$i18n.locale);
  },
  watch: {
    "$i18n.locale"(newLang) {
      this.loadPrivacyContent(newLang);
    },
  },
  methods: {
    loadPrivacyContent(lang) {
      const fallbackLang = "en";

      const contentMap = {
        ar: arHtml,
        ch: chHtml,
        en: enHtml,
        de: deHtml,
        en: enHtml,
        es: esHtml,
        fr: frHtml,
        ja: jaHtml,
        tu: tuHtml,
      };

      this.content =
        contentMap[lang] ||
        contentMap[fallbackLang] ||
        "<p>Data Privacy content not available.</p>";
    },
  },
};
</script>

<style lang="scss">
.privacy-content {
  padding: 1rem;
  font-size: 1rem;
  max-width: 100%;
  overflow-x: auto;
  word-break: break-word;
  img,
  table {
    max-width: 100%;
    height: auto;
  }
  h1,h2,h3,h4,h5,h6{
    margin-bottom: 6px;
    line-height: 1.6;
  }
  p{
    margin-bottom: 10px;
    line-height: 1.6;
    font-size: 1.1rem;
  }
}
</style>
